import instance from "../interceptor";

/**
 * Downloads the user's data archive.
 *
 * Stays off RTK Query on purpose: the response is a `responseType: "blob"` zip
 * stream and the only outcome is a browser download, so there is no server
 * state to cache. `axiosBaseQuery` deliberately doesn't forward `responseType`.
 */
export const exportUserData = async () => {
  const response = await instance.get("/auth/export", {
    responseType: "blob",
  });

  // Create a download link in browser
  const url = globalThis.window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "account_data.zip");
  document.body.appendChild(link);
  link.click();
  link.remove();
};
